import { render, staticRenderFns } from "./WorkBaseLevelTableLookALikeUnit.vue?vue&type=template&id=4860333f&scoped=true"
import script from "./WorkBaseLevelTableLookALikeUnit.vue?vue&type=script&lang=js"
export * from "./WorkBaseLevelTableLookALikeUnit.vue?vue&type=script&lang=js"
import style0 from "./WorkBaseLevelTableLookALikeUnit.vue?vue&type=style&index=0&id=4860333f&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4860333f",
  null
  
)

export default component.exports